'use client';

import Link from 'next/link';
import { type JSX, type ReactNode } from 'react';

import { useSearchResults } from '../_hooks';
import { getKeywordSearchUrl } from '../_utils';

interface KeywordSearchLinkProps {
    className?: string;
    children: ReactNode;
}

/**
 * Keyword-search fallback link for the in-conversation redirect cases (chat
 * error / usage limit). Reads the latest results from the live thread and points
 * at the keyword-search page that matches their media type — single-type
 * results go to that type's search, everything else (mixed cross-asset or no
 * results) defaults to video.
 *
 * Must be rendered inside `ChatRuntimeProvider` (it reads the thread). The
 * no-signal gates — visitor demo and expired experience — render outside the
 * runtime and link to `/video/search` directly instead.
 */
export function KeywordSearchLink({ className, children }: KeywordSearchLinkProps): JSX.Element {
    const { results } = useSearchResults();

    return (
        <Link href={getKeywordSearchUrl(results)} className={className}>
            {children}
        </Link>
    );
}
